export default __webpack_public_path__ + "static/media/partners8.fc4738a6.png";